import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section id="pricing" className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-navy/20 bg-navy/10 px-4 py-2">
            <i className="ri-rocket-2-line text-sm text-navy"></i>
            <span className="text-sm font-semibold text-navy">Faites votre premier pas</span>
          </div>
          <h2 className="mb-4 text-4xl font-bold text-navy md:text-5xl">
            Prêt à rejoindre
            <br />
            <span className="text-gold">Foi Senegal ?</span>
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-500">
            Que vous soyez vendeur ou organisateur, votre place est ici. Créez votre compte dès maintenant et rejoignez une communauté dynamique d'entrepreneurs africains.
          </p>
        </div>

        <div className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2">
          <div className="group relative overflow-hidden rounded-3xl border-2 border-gray-100 bg-white transition-all duration-300 hover:border-emerald-200">
            <div className="absolute left-0 right-0 top-0 h-1 bg-gradient-to-r from-emerald-400 to-teal-500"></div>
            <div className="p-8">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100">
                <i className="ri-store-2-line text-2xl text-emerald-600"></i>
              </div>
              <h3 className="mb-2 text-2xl font-bold text-navy">Vendeur</h3>
              <p className="mb-6 text-sm leading-relaxed text-gray-500">
                Ouvrez votre boutique en ligne, vendez vos produits à des milliers de clients et développez votre business sur Foi Senegal.
              </p>
              <ul className="mb-8 space-y-2.5">
                {[
                  'Boutique personnalisée',
                  'Gestion des produits & stocks',
                  'Suivi des commandes',
                  'Statistiques de ventes',
                  'Notifications en temps réel',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-gray-600">
                    <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100">
                      <i className="ri-check-line text-xs text-emerald-600"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => navigate('/register?role=vendor')}
                className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-navy py-3.5 text-sm font-bold text-white transition-all hover:bg-navy-light"
              >
                <i className="ri-store-2-line"></i>
                Je veux être vendeur
              </button>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-3xl border-2 border-navy bg-navy">
            <div className="absolute left-0 right-0 top-0 h-1 bg-gradient-to-r from-gold to-gold-light"></div>
            <div className="absolute right-4 top-4 rounded-full bg-gold px-3 py-1 text-xs font-bold text-white">
              Populaire
            </div>
            <div className="p-8">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-gold/20">
                <i className="ri-calendar-event-line text-2xl text-gold"></i>
              </div>
              <h3 className="mb-2 text-2xl font-bold text-white">Organisateur</h3>
              <p className="mb-6 text-sm leading-relaxed text-white/60">
                Créez et gérez vos événements, vendez vos tickets en ligne et analysez vos performances financières.
              </p>
              <ul className="mb-8 space-y-2.5">
                {[
                  "Création d'événements illimitée",
                  'Vente de tickets en ligne',
                  'Gestion des participants',
                  'Tableau de bord financier',
                  'Billets QR code sécurisés',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-white/80">
                    <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-gold/20">
                      <i className="ri-check-line text-xs text-gold"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => navigate('/register?role=organizer')}
                className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-gold py-3.5 text-sm font-bold text-white transition-all hover:bg-gold-dark"
              >
                <i className="ri-calendar-event-line"></i>
                Je veux être organisateur
              </button>
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-3xl border border-gold/30 bg-white p-8 md:p-12">
          <img
            src="https://readdy.ai/api/search-image?query=african%20entrepreneurs%20team%20working%20digital%20marketplace%20together%20modern%20office%20vibrant%20energy%20creative%20startup%20africa%20technology%20warm%20colors&width=1200&height=400&seq=fsn-cta01&orientation=landscape"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-top opacity-10"
          />
          <div className="relative z-10 flex flex-col items-center justify-between gap-8 md:flex-row">
            <div>
              <h3 className="mb-3 text-2xl font-bold text-navy md:text-3xl">Votre aventure commence ici.</h3>
              <p className="max-w-xl text-base text-gray-500">
                Rejoignez plus de <strong className="text-navy">1 200 entrepreneurs</strong> qui ont déjà fait confiance à Foi Senegal pour développer leur activité. L'inscription est gratuite, la validation rapide.
              </p>
            </div>
            <div className="flex flex-shrink-0 flex-col gap-4 sm:flex-row">
              <button
                onClick={() => navigate('/register')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-gold px-8 py-4 text-sm font-bold text-white transition-all hover:bg-gold-dark"
              >
                <i className="ri-user-add-line"></i>
                Créer mon compte
              </button>
              <button
                onClick={() => navigate('/login')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border-2 border-navy px-8 py-4 text-sm font-bold text-navy transition-all hover:bg-navy hover:text-white"
              >
                <i className="ri-login-box-line"></i>
                Se connecter
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
